import { render, staticRenderFns } from "./wizard0.vue?vue&type=template&id=ad391eda"
import script from "./wizard0.vue?vue&type=script&lang=js"
export * from "./wizard0.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/product/wizard0.vue
// module id = null
// module chunks = 